import { RadioGroup } from "@headlessui/react";
import { useTranslation } from "react-i18next";

import { stepHeadingClassName } from "@/components/Portal/UserAccount/Security/AuthenticatorSetup/authenticator.utils";
import {
  TwoFactorMethodOption,
  twoFactorMethodOrder,
} from "@/components/Portal/UserAccount/Security/AuthenticatorSetup/AuthenticatorSetupForm";
import { ChangeTwoFactorAuthenticationMethod } from "@/services/model";

type Props = {
  /** The user's current method; every other method is offered. */
  currentMethod: ChangeTwoFactorAuthenticationMethod;
  value: ChangeTwoFactorAuthenticationMethod | null;
  onChange: (method: ChangeTwoFactorAuthenticationMethod) => void;
};

/** "Change 2FA log in method" section of the 2FA settings card. */
export const TwoFactorAlternatives = ({
  currentMethod,
  value,
  onChange,
}: Props) => {
  const { t } = useTranslation();
  const title = t("portal:user-account.security.2fa.changeOption");

  return (
    <div className="flex flex-col gap-4">
      <h3 className={stepHeadingClassName}>{title}</h3>
      <RadioGroup
        className="flex flex-col gap-4"
        value={value}
        onChange={(method: ChangeTwoFactorAuthenticationMethod | null) =>
          method && onChange(method)
        }
        aria-label={title}
      >
        {twoFactorMethodOrder
          .filter((method) => method !== currentMethod)
          .map((method) => (
            <TwoFactorMethodOption key={method} method={method} />
          ))}
      </RadioGroup>
    </div>
  );
};
